type ReportDataEffectProps = { keyRecoil: string };

/**
 * Placeholder store-effect component for the PDF report tab, wired in but carrying no logic yet. Logs the tab key it was given and renders nothing.
 *
 * @param keyRecoil - Tab key this effect would be bound to.
 * @returns Null — the component renders no markup.
 */
const ReportDataEffect = ({ keyRecoil }: ReportDataEffectProps): null => {
  console.log('ReportDataEffect', keyRecoil);
  // use recoil getter

  // use recoil setter

  // use recoil value

  // use recoil getter not keyRecoil

  // use recoil setter not keyRecoil

  // use recoil state

  return null;
};

export default ReportDataEffect;
